var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAction3DtrackColored({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58359 8C7.35982 8 8.12538 7.81927 8.81966 7.47214L14.2859 4.73901C15.2579 4.25302 16.3297 4 17.4164 4H22V16H17.4164C16.6402 16 15.8746 16.1807 15.1803 16.5279L9.71409 19.261C8.7421 19.747 7.67031 20 6.58359 20H2V8H6.58359Z",
    fill: "url(#paint0_linear_1598_9233)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2859 14.739C15.2579 14.253 16.3297 14 17.4164 14H22V16H17.4164C16.6402 16 15.8746 16.1807 15.1803 16.5279L9.71409 19.261C8.7421 19.747 7.67031 20 6.58359 20H2V18H6.58359C7.35982 18 8.12538 17.8193 8.81966 17.4721L14.2859 14.739Z",
    fill: "#4B3553"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1598_9233",
    x1: 2,
    y1: 19.9992,
    x2: 22,
    y2: 19.9992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0989583,
    stopColor: "#5ADC5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#D4EF32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434375,
    stopColor: "#54E647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678125,
    stopColor: "#5BDD5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3374D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAction3DtrackColored);
export default __webpack_public_path__ + "static/media/ic_action_3dtrack_colored.b258f09f7ae250b565b1785c56e86dbf.svg";
export { ForwardRef as ReactComponent };